'use client';
import { useState } from 'react';

export interface ToolCallEvent {
  source?: string;
  tool?: string;
  action?: string;
  data?: Record<string, unknown>;
  timestamp?: number;
}

interface ToolCallChipProps {
  event: ToolCallEvent;
}

export default function ToolCallChip({ event }: ToolCallChipProps) {
  const [open, setOpen] = useState(false);
  const tool = event.tool ?? 'tool';
  const action = event.action ?? 'started';
  const ts = event.timestamp ? new Date(event.timestamp * 1000).toLocaleTimeString() : '';
  const marker = action === 'completed' ? 'ok' : '...';
  return (
    <div
      className="mobeus-tool-chip" part="tool-chip"
      style={{
        margin: '6px 0',
        padding: '4px 8px',
        borderRadius: 8,
        background: 'var(--mobeus-surface-muted, #f3f4f6)',
        border: '1px solid var(--mobeus-border, #e5e7eb)',
        fontSize: 12,
        fontFamily: 'var(--mobeus-font, system-ui, sans-serif)',
        color: 'var(--mobeus-text-muted, #374151)',
        cursor: 'pointer',
      }}
      onClick={() => setOpen((v) => !v)}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <span aria-hidden="true" style={{ fontFamily: 'monospace' }}>{marker}</span>
        <span style={{ fontWeight: 600 }}>{tool}</span>
        <span style={{ color: 'var(--mobeus-text-muted, #6b7280)' }}>{action}</span>
        {ts && <span style={{ color: 'var(--mobeus-text-faint, #9ca3af)', marginLeft: 'auto' }}>{ts}</span>}
      </div>
      {open && event.data && (
        <pre style={{
          margin: '6px 0 0',
          padding: 6,
          background: 'var(--mobeus-surface, #fff)',
          border: '1px solid var(--mobeus-border, #e5e7eb)',
          borderRadius: 4,
          fontSize: 11,
          overflowX: 'auto',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
        }}>{JSON.stringify(event.data, null, 2)}</pre>
      )}
    </div>
  );
}
